import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.views.ContactListTable.';
  public static readonly contact = `${Id.prefix}contact`;
  public static readonly primary = `${Id.prefix}primary`;
  public static readonly client = `${Id.prefix}client`;
  public static readonly email = `${Id.prefix}email`;
  public static readonly role = `${Id.prefix}role`;
  public static readonly phone = `${Id.prefix}phone`;
}

export class LangContactListTable {
  private constructor() {}
  public static contact(): string {
    return interpolate(Id.contact);
  }
  public static primary(): string {
    return interpolate(Id.primary);
  }
  public static client(): string {
    return interpolate(Id.client);
  }
  public static email(): string {
    return interpolate(Id.email);
  }
  public static role(): string {
    return interpolate(Id.role);
  }
  public static phone(): string {
    return interpolate(Id.phone);
  }
}

export class ContactListTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.contact, "{{glossary 'contact'}}", 'Column header for contact name');
    register.add(Id.primary, 'Primary', 'Column header for primary contact');
    register.add(Id.client, "{{glossary 'client'}}", 'Column header for client name');
    register.add(Id.email, 'Email', 'Column header for email');
    register.add(Id.role, 'Role', 'Column header for role');
    register.add(Id.phone, 'Phone', 'Column header for phone');
  }
}
